export default __webpack_public_path__ + "static/media/Statistics_2007.ba1c036d.zip";